export default "__VITE_ASSET__N3HI35Q1__"